export default "__VITE_PUBLIC_ASSET__7c7cc379__"